import { cva } from "class-variance-authority";

/**
 * Shared styling constants for dropdown components
 * Used by SingleSelectInput, MultipleSelectInput, and other dropdown-based components
 */

/**
 * Dropdown container variant styles
 * Provides consistent styling for dropdown containers with optional border
 */
export const DROPDOWN_VARIANTS = cva("overflow-hidden rounded-1 bg-neutral-0", {
	variants: {
		hasBorder: {
			true: "ring-1 ring-neutral-3",
		},
	},
	defaultVariants: {
		hasBorder: true,
	},
});

/**
 * Dropdown animation classes for Radix UI components
 * Provides consistent enter/exit animations for dropdowns
 */
export const DROPDOWN_ANIMATIONS =
	"data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2";

/**
 * Scroll styling for dropdown content areas
 * Provides consistent scrollbar appearance and behavior
 * Uses PY neutral colors: neutral-4 (#9197A1) and neutral-1 (#F5F5F5)
 */
export const SCROLL_STYLES = {
	scrollbarWidth: "thin" as const,
	scrollbarColor: "#9197A1 #F5F5F5",
} as const;

/**
 * Clear button styling for input components
 * Provides consistent positioning and styling for clear buttons
 */
export const CLEAR_BUTTON_BASE_STYLES =
	"absolute right-8 top-1/2 z-10 inline-flex -translate-y-1/2 items-center justify-center rounded-1 border-none bg-transparent p-0 hover:cursor-pointer";

/**
 * Minimum number of options required to show search bar in combobox variant
 * Controls when the search input appears in dropdown components
 */
export const COMBOBOX_SEARCH_THRESHOLD = 7;
